import { Attribute } from "../../../../types/prodcatBaseTypes";
import { sizeAndFitAttributesByCategory } from "./sizeAndFitUtilsData";

export function getSizeAndFitAttributes(
  browsePageHierarchyCategoryIds: string[] = [],
  attributes: Attribute[],
) {
  const sizeAndFitAttributeData = sizeAndFitAttributesByCategory.find(
    ({ categories }) =>
      categories.some((category) =>
        browsePageHierarchyCategoryIds.includes(category.categoryId),
      ),
  );

  if (!sizeAndFitAttributeData) return [];

  return attributes
    .filter((attr) => sizeAndFitAttributeData.attributeKeys.includes(attr.key))
    .filter((attr) => (attr.values || []).length > 0)
    .sort(
      (a, b) =>
        sizeAndFitAttributeData.attributeKeys.indexOf(a.key) -
        sizeAndFitAttributeData.attributeKeys.indexOf(b.key),
    );
}
